export default {
  // '工作台': '工作台1'
  '设备名称': 'device name',
  '设备数量(个)': 'device count',
  '报警信息(条)': 'alarm count',
  '用户数量(个)': 'user count',
  '故障设备数(个)': 'alarm device count',
  '设备报警率': 'device alarm rate',
  '设备状态占比': 'device status ratio',
  '设备使用率': 'device usage rate',
  '故障报警率': 'alarm rate',
  '设备故障率': 'device alarm rate',
  '设备总数': 'device count',
  '1月': 'January',
  '2月': 'February',
  '3月': 'March',
  '4月': 'April',
  '5月': 'May',
  '6月': 'June',
  '7月': 'July',
  '8月': 'August',
  '9月': 'September',
  '10月': 'October',
  '11月': 'November',
  '12月':'December',
  '登录账号': 'login account',
  '用户昵称': 'user nickname',
  '手机号': 'phone number',
  '角色': 'role',
  '状态': 'status',
  '操作': 'operation',
  '创建时间': 'create time',
  '修改时间': 'update time',
  '操作': 'operation',
  '编辑': 'update',
  '删除': 'delete',
  '重置密码': 'reset password',
  '确认': 'confirm',
  '取消': 'cancel',
  '重置': 'reset',
  '保存': 'save',
  '新增': 'add',
  '查询': 'query',
  '导出': 'export',
  '禁用': 'disable',
  '日志': 'log',
  '详情': 'detail',
  '最后登录IP': 'last login ip',
  '最后登录时间': 'last login time',
  '启用': 'enable',
  '在线': 'online',
  '离线': 'offline',
  '在线/离线': 'online/offline',
  '用户名称': 'user name',
  '负责人': 'principal',
  '日期范围': 'date range',
  '设备':'device',
  '绑定': 'bind',
  '解绑': 'unbind',
  '设备ID': 'device id',
  '设备编号': 'device num',
  '在线状态': 'online status',
  '负责人电话': 'principal phone',
  '邮箱': 'email',
  '备注': 'remark',
  '地址': 'address',
  '所属经销商': 'dealer',
  '设备型号': 'device model',
  '设备容量': 'device capacity',
  '设备类型': 'device type',
  '设备状态': 'device status',
  '联系电话': 'phone',
  '电池组数量': 'battery group count',
  '电池组PACK厂家': 'battery group pack factory',
  '电池串数量': 'battery string count',
  '电池类型': 'battery type',
  '客户代码': 'customer code',
  'BOM编码版本': 'bom code version',
  '电芯品牌': 'battery cell brand',
  'bms从控品牌': 'bms slave brand',
  '液冷机组品牌': 'liquid coolant group brand',
  '液冷机组个数': 'liquid coolant group count',
  '液冷机组规格': 'liquid coolant group spec',
  '线束供应商': 'wire supplier',
  '充电枪品牌': 'charging gun brand',
  '充电枪数量': 'charging gun count',
  '直流充电座品牌': 'dc charging seat brand',
  'dcdc模块品牌': 'dcdc module brand',
  'dcdc模块型号': 'dcdc module model',
  'acdc模块品牌': 'acdc module brand',
  'pcs品牌': 'pcs brand',
  '光伏控制器品牌': 'photovoltaic controller brand',
  '光伏控制器功率': 'photovoltaic controller power',
  '辅助电源规格': 'auxiliary power spec',
  '显示屏参数': 'display parameter',
  '主控数量及软件版本号': 'main control count and software version number',
  'can盒规格': 'can box spec',
  '绝缘检测模块品牌': 'insulation detection module brand',
  '控制系统架构': 'control system architecture',
  'gps编号': 'gps number',
  '4G平台gsm卡编号': '4g platform gsm card number',
  '充电主控品牌': 'charging main control brand',
  '充电主控软件版本号': 'charging main control software version number',
  'opcc软件版本号': 'opcc software version number',
  '销售区域': 'sales area',
  '产品铭牌信息': 'product plate information',
  '业务员': 'salesman',
  '图片附件': 'picture attachment',
  '电池信息': 'battery information',
  '数据': 'data',
  '设备报警': 'device alarm',
  '信息概览': 'information overview',
  '查看详情': 'view details',
  '电池串': 'battery string',
  '电池组': 'battery group',
  'EV充电信息': 'EV charging information',
  'PCS信息': 'PCS information',
  '光伏充电信息': 'photovoltaic charging information',
  'AC补能信息': 'AC backup information',
  '触发器名称': 'trigger name',
  '故障码': 'fault code',
  '报警值': 'alarm value',
  '报警设备': 'alarm device',
  '报警详情': 'alarm details',
  '报警时间': 'alarm time',
  '批量删除': 'batch delete',
  '客户名称': 'customer name',
  '客户ID':'customer id',
  '所属地区': 'belonging area',
  '详细地址': 'detailed address',
  '升级类型': 'upgrade type',
  '终端': 'terminal',
  '版本号': 'version number',
  '版本名称': 'version name',
  '更新类型': 'update type',
  '计划更新': 'plan update',
  '计划更新时间': 'plan update time',
  '更新内容': 'update content',
  '升级记录': 'upgrade record',
  '更新时间': 'update time',
  '成功': 'success',
  '失败':'failed',
  '升级中': 'upgrading',
  '待升级': 'to be upgraded',
  '升级完成': 'upgrade complete',
  '升级失败': 'upgrade failed',
  '升级取消': 'upgrade canceled',
  '返回': 'return',
  '整包更新': 'whole package update',
  '应用包资源': 'application package resources',
  '指定类型': 'specify type',
  '立即更新': 'immediate update',
  '文件上传': 'file upload',
  '全部': 'all',
  '指定设备':'specify device',
  '设备列表':'device list',
  '客户列表':'customer list',
  '消息标题':'message title',
  '消息类型':'message type',
  '图片':'picture',
  '发送用户':'send user',
  '已读数':'read count',
  '使用设备': 'in use device',
  '故障设备': 'alarm device',
  '区域':'area',
  '用户名': 'username',
  '登录密码': 'password',
  '头像': 'avatar',
  '根region': 'root region',
  '正常': 'enable',
  '确定': 'confirm',
  '确认密码': 'confirm password',
  '登录地址': 'login address',
  '登录状态': 'login status',
  '登录时间': 'login time',
  '访问编号': 'access number',
  '登录地点': 'login place',
  '浏览器': 'browser',
  '操作系统': 'operation system',
  '登录信息': 'login information',
  '基本信息': 'basic information',
  '场地列表': 'site list',
  '联系方式': 'contact information',
  '重置登录密码': 'reset password',
  '清空': 'clear',
  '提交': 'submit',
  '用户列表': 'user list',
  '用户总数': 'user total',
  '批量绑定': 'batch bind',
  '批量解绑': 'batch unbind',
  '光伏侧数据': 'photovoltaic side data',
  '电池组信息': 'battery group information',
  '充电枪': 'charging gun',
  '组': 'group',
  '日': 'day',
  '周': 'week',
  '月': 'month',
  '电流': 'current',
  '电压': 'voltage',
  '枪': ' gun',
  '电池总电压': 'battery total voltage',
  '电池总电流': 'battery total current',
  '电池最高电压': 'battery voltage',
  '电池最低电压': 'battery voltage',
  '电池最高温度': 'battery temperature',
  '电池最低温度': 'battery temperature',
  '重新升级': 're-upgrade',
  'pcs规格型号': 'pcs spec model',
  '电池信息一组':'battery information group one',
  '电池信息二组':'battery information group two',
  '电池信息三组':'battery information group three',
  '电池信息四组':'battery information group four',
  '电池信息五组':'battery information group five',
  '主板': 'mainboard',
  '未处理':'unprocessed',
  '已恢复':'recovered',
  '新增设备类型': 'add device type',
  '报警': 'alarm',
  '规则名称': 'rule name',
  '触发属性': 'trigger property',
  '触发条件': 'trigger condition',
  '触发值下限': 'trigger value lower limit',
  '触发值上限': 'trigger value upper limit',
  '排序': 'sort',
  '通讯类型': 'communication type',
  '配网方式': 'network configuration method',
  '通讯协议': 'communication protocol',
  '设备协议': 'device protocol',
  '复制': 'copy',
  '预览': 'preview',
  "成功": "success",
  "失败": "failed",
  '消息简述': 'message brief',
  '消息图片': 'message picture',
  '消息内容': 'message content',
  '消息终端': 'message terminal',
  '系统消息': 'system message',
  '请输入': 'please enter',
  '确定要禁用该用户吗': 'Are you sure you want to disable this user?',
  '确定要启用该用户吗': 'Are you sure you want to enable this user?',
  '数据删除后无法恢复，请确认': 'The data will be deleted and cannot be recovered. Please confirm.',
  '列表选取': 'list selection',
  '客户状态':'customer status',
  '确定要将该设备与当前经销商信息解绑吗': 'Are you sure you want to unbind the current dealer information from the device?',
  '信息': 'information',
  '电池一组': 'battery group one',
  '电池二组': 'battery group two',
  '电池三组': 'battery group three',
  '电池四组': 'battery group four',
  '电池五组': 'battery group five',
  '电池单体电压': 'battery single voltage',
  '电池温度':'battery temperature',
  '版本code': 'version code',
  '最近上报时间': 'latest report time',
  '报警信息': 'alarm information',
  '批量新增': 'batch add',
  'AC补能': 'ac backup',
  '充电电量': 'charge energy',
  '实时功率': 'implementation power',
  '单次并网充电电量': 'single and grid charge current',
  '累计并网充电电量': 'accumulated and grid charge current',
  '经销商': 'dealer',
  '联系人': 'contact',
  '添加子设备': 'add subdevice',
  '更多': 'more',
  '序号': 'serial number',
  '自动获取': 'auto get',
  '电池箱数量': 'battery box number',
  '显示屏数量': 'display number',
  '光伏控制器个数': 'photovoltaic controller number',
  'pcs个数': 'pcs number',
  'acdc模块个数': 'acdc module number',
  'dcdc模块个数': 'dcdc module number',
  '直流充电座型号': 'dcdc charge seat model',
  '直流充电座数量': 'dcdc charge seat number',
  '充电枪型号': 'charging gun model',
  '4G模块序列号': '4g module serial number',
  '液冷机组品牌型号': 'liquid coolant group brand model',
  'dcdc模块品牌型号': 'dcdc module brand model',
  'acdc模块品牌型号': 'acdc module brand model',
  'pcs品牌型号': 'pcs brand model',
  '光伏控制器品牌型号': 'photovoltaic controller brand model',
  '4G卡号':'4g card number',
  '请输入设备名称': 'please enter device name',
  '请输入设备编号': 'please enter device number',
  '请输入联系人': 'please enter contact person',
  '请输入联系电话': 'please enter phone number',
  '端口地址': 'port address',
  '参数展示': 'parameter display',
  '断开':'disconnect',
  '正常':'normal',
  '请输入设备名称': 'please enter device name',
  '请输入设备编号': 'please enter device number',
  '请输入联系人': 'please enter contact person',
  '请输入联系电话': 'please enter phone number',
  '端口地址': 'port address',
  '参数展示': 'parameter display',
  '用户等级': 'user level',
  '等级': 'level',
  '2级': '2 level',
  '3级': '3 level',
  '升级名单': 'upgrade list',
  'IO控制': 'io control',
  'DI1数字输入' : 'DI1 digital input',
  'DI2数字输入' : 'DI2 digital input',
  'DO1数字输入': 'DO1 digital input',
  'DO2数字输入': 'DO2 digital input',
  '开机':'boot up',
  '关机':'shut down',
  '无' : 'none',
  '升级包': 'upgrade package',
  '批量升级': 'batch upgrade',
  '固件版本': 'firmware version',
  '是否调试中': 'is debugging',
  '设备参数': 'device parameters',
  '名称': 'name',
  '值': 'value',











 



}
